import * as constants from "./constants";

// Login
export const loginRequest = (payload: { email: string; password: string }, history: any) => {
    return { type: constants.LOGIN_REQUESTING, payload, history }
}

export const loginSuccess = (payload: any) => {
    return { type: constants.LOGIN_SUCCESS, payload }
}

export const loginFailed = (error: any) => {
    return { type: constants.LOGIN_FAILED, error }
}

// Token refresh
export const tokenRefreshSuccess = (access: string) => {
    return { type: constants.TOKEN_REFRESH_SUCCESS, access }
}

// Fetch profile
export const fetchProfileRequest = () => {
    return { type: constants.FETCH_PROFILE_REQUESTING }
}

export const fetchProfileSuccess = (payload: any) => {
    return { type: constants.FETCH_PROFILE_SUCCESS, payload }
}

export const fetchProfileFailed = (error: any) => {
    return { type: constants.FETCH_PROFILE_FAILED, error }
}

// Update profile
export const updateProfileRequest = (payload: any, callback?: () => void) => ({
    type: constants.UPDATE_PROFILE_REQUESTING, payload, callback,
});
export const updateProfileSuccess = (payload: any) => ({
    type: constants.UPDATE_PROFILE_SUCCESS, payload,
});
export const updateProfileFailed = (error: any) => ({
    type: constants.UPDATE_PROFILE_FAILED, error,
});

// Change password
export const changePasswordRequest = (payload: { old_password: string; new_password: string }, callback?: () => void) => ({
    type: constants.CHANGE_PASSWORD_REQUESTING, payload, callback,
});
export const changePasswordSuccess = () => ({
    type: constants.CHANGE_PASSWORD_SUCCESS,
});
export const changePasswordFailed = (error: any) => ({
    type: constants.CHANGE_PASSWORD_FAILED, error,
});

// Logout
export const logoutRequest = (history: any) => {
    return { type: constants.LOGOUT, history }
}
